import type { ReactNode } from 'react';
import { cn } from './cn';

interface CardProps {
  children: ReactNode;
  className?: string;
  /** Removes inner padding (for tables / maps that bleed to the edges). */
  flush?: boolean;
}

/** Card surface — white, hairline border, soft shadow; the base container for
 *  every console section. (See `.panel` in index.css for the light tokens.) */
export function Card({ children, className, flush }: CardProps) {
  return <div className={cn('panel', flush ? '' : 'p-5', className)}>{children}</div>;
}

interface CardHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  right?: ReactNode;
  className?: string;
}

/** Standard card header: title + optional subtitle on the left, actions on the right. */
export function CardHeader({ title, subtitle, right, className }: CardHeaderProps) {
  return (
    <div className={cn('flex items-start justify-between gap-3', className)}>
      <div className="min-w-0">
        <h3 className="truncate text-[15px] font-semibold text-slate-100">{title}</h3>
        {subtitle ? <p className="mt-0.5 truncate text-[13px] text-text-secondary">{subtitle}</p> : null}
      </div>
      {right ? <div className="shrink-0">{right}</div> : null}
    </div>
  );
}
